import React from 'react';
import { SWRConfig, mutate } from 'swr';
import {createRoot} from 'react-dom/client'
import Routes from './Routes';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from './contexts/ConfigContext';
import './index.css'

const domNode = document.getElementById('root') as HTMLElement
const root = createRoot(domNode)

root.render(
  <ConfigProvider>
    <SWRConfig 
      value={{
        onError: (error, key) => {
          if (error.status === 240) {
            // Mutate the token key to trigger a refresh
            // The key in useAuth.ts is dynamic, but we can target it generally or by knowing the endpoint
            // In useAuth.ts: ['/security/auth/create-session', keyData.data]
            mutate(
              (k: any) => Array.isArray(k) && k[0] === '/security/auth/create-session',
              undefined,
              { revalidate: true }
            );
          }
        }
      }}
    >
      <Routes/>
    </SWRConfig>
  </ConfigProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
